var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOctavoLogoDark = function SvgOctavoLogoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "423.658px",
    height: "118.622px",
    viewBox: "0 0 423.658 118.622",
    enableBackground: "new 0 0 423.658 118.622",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.341,
    y: 34.743,
    fill: "none",
    width: 304.317,
    height: 61.069
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M122.46,65.657c0-16.703,12.852-29.357,30.021-29.357c17.104,0,29.89,12.589,29.89,29.357 c0,16.769-12.786,29.357-29.89,29.357C135.312,95.015,122.46,82.36,122.46,65.657z M170.039,65.658 c0-10.208-7.533-17.871-17.557-17.871s-17.688,7.744-17.688,17.871c0,10.127,7.664,17.871,17.688,17.871 S170.039,75.865,170.039,65.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M211.314,95.014c-13.057,0-23.044-10.054-23.044-23.059c0-13.005,9.922-22.796,23.11-22.796 c11.237,0,19.96,7.124,22.071,17.806h-11.653c-1.9-4.267-5.809-6.773-10.485-6.773c-6.363,0-11.149,5.108-11.149,11.83 c0,6.723,4.866,11.961,11.149,11.961c4.742,0,8.49-2.638,10.47-7.277h11.814C231.552,87.613,222.667,95.015,211.314,95.014 L211.314,95.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M267.662,83.339v10.448h-8.337c-9.548,0-15.415-5.867-15.415-15.496v-18.47h-7.847v-2.536l17.14-18.222 h2.243v11.325h11.975v9.433h-11.777v16.914c0,4.193,2.411,6.604,6.685,6.604H267.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M319.455,50.323v43.399h-9.198l-1.008-3.882c-3.727,3.263-8.589,5.176-14.064,5.176 c-13.056,0-22.766-9.856-22.766-22.993c0-13.085,9.71-22.862,22.766-22.862c5.57,0,10.507,1.964,14.258,5.309l1.254-4.147 L319.455,50.323z M307.955,72.023c0-6.816-4.997-11.895-11.814-11.895s-11.829,5.093-11.829,11.895 c0,6.803,5.012,11.895,11.829,11.895S307.955,78.84,307.955,72.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M371.354,50.388l-17.243,43.399h-10.828l-17.659-43.399h12.516l10.623,29.078l10.435-29.078H371.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005792",
    d: "M373.206,72.088c0-13.167,10.017-22.928,23.46-22.928c13.377,0,23.46,9.776,23.46,22.928 c0,13.085-10.083,22.927-23.46,22.927C383.222,95.015,373.206,85.173,373.206,72.088z M408.231,72.088 c0-7.028-4.8-11.895-11.565-11.895S385.1,65.06,385.1,72.088c0,7.029,4.8,11.895,11.565,11.895S408.231,79.117,408.231,72.088z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#112249",
    points: "39.631,35.765 0,35.765 18.366,0 57.997,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005792",
    points: "18.366,75.455 57.997,75.455 39.631,39.69 0,39.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#19BAED",
    points: "62.772,75.455 102.403,75.455 84.038,39.69 44.407,39.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#97D8E8",
    points: "84.038,115.145 44.407,115.145 62.772,79.38 102.403,79.38  "
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOctavoLogoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Octavo_logo_dark.461ea985.svg";
export { ForwardRef as ReactComponent };